module.exports = __webpack_public_path__ + "static/carry-35fd57aa27ab597f486740ebce46e9e3.jpg";